import requests from '@/utils/requests';

/**
 * 查询短信验证码接口
 * @param {*} data
 */
export function querySmsCode (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/tools/querySmsCode',
    method: 'post',
    data
  });
}
